/*
 * Lib Devtools
 */

class Devtools extends LibModule {

    constructor() {
        super();

        this.caughtErrors = [];

        let self = this;
        window.onerror = function(msg, url, line) {
            self._putError.apply(self, [msg, url, line]);
        };
    }

    DOMReady() {

        let self = this;

        let devTools = $('#dev-tools');
        if (devTools.length) {

            let appDevTools = Lib.Util.getOption('data.app-dev-tools');
            if (appDevTools) {
                $(appDevTools).each(function(key, devtool) {
                    self.newDevtool(devtool);
                });
            }

            $(document).on('click', '#dev-tools [data-devtool]', function(e) {
                e.preventDefault();
                let currentDevTool = $(this).data('devtool');
                $(Lib).trigger('dev-tool.' + currentDevTool + '.click', [$(this)]);
            });

            $(document).on('contextmenu', '#dev-tools [data-devtool]', function(e) {
                e.preventDefault();
                let currentDevTool = $(this).data('devtool');
                $(Lib).trigger('dev-tool.' + currentDevTool + '.rightclick', [$(this)]);
            });

            $(Lib).on('dev-tool.js-errors.click', function(e, devToolEl) {
                self.jsErrorModal();
            });

            $(Lib).on('dev-tool.element-outline.click', function(e, devToolEl) {
                devToolEl.toggleClass('bg-primary');
                $('body').toggleClass('dev-tools-outline');
            });

            this.cakeDebugs();
            this.ajaxDebugs();

            if (devTools.find('> div').length) {
                devTools.show();
            }
        }

    }

    afterDOMReady() {
        this.checkJsErrors();
    }

    checkJsErrors() {
        let jsErrorsEl = this.getDevToolEl('js-errors');
        if (this.caughtErrors.length !== 0) {
            jsErrorsEl.addClass('bg-danger');
        }
    }

    /**
     *
     */
    cakeDebugs() {

        let debugDevToolEl = this.getDevToolEl('cake-debug');

        // Cake debugs
        let cakeDebugs = $('.cake-debug-output, .cake-error');

        if (cakeDebugs.length > 0) {
            let color = 'bg-primary';
            if ($('.cake-error').length) {
                color = 'bg-danger';
            }

            debugDevToolEl.addClass(color);

            $(Lib).on('dev-tool.cake-debug.click', function() {
                Lib.Modal.createFromTemplate('debug-output', {}, {
                    onOpen: function() {
                        let clones = cakeDebugs.clone();
                        let cloneHtml = $('<div />').append(clones.show()).html();
                        cloneHtml = cloneHtml.replace(/-trace/g, '-trace-clone');
                        cloneHtml = cloneHtml.replace(/-code/g, '-code-clone');
                        cloneHtml = cloneHtml.replace(/-context/g, '-context-clone');
                        $('[data-debugoutput]').html(cloneHtml).find('.cake-debug-output, .cake-error').css('z-index', 3);
                    },
                    large: true
                });
            });

            $(Lib).on('dev-tool.cake-debug.rightclick', function() {
                $('.cake-error:not(.modal .cake-error), .cake-debug-output:not(.modal .cake-debug-output)').toggle();
            });
        }

    };

    ajaxDebugs() {
        const self = this;
        let responseFunction = function(e, xhr, settings) {
            if (xhr && 'responseText' in xhr && xhr.responseText) {
                let debugResult = self.filterDebugMessage(xhr.responseText);
                if (debugResult.length) {
                    Lib.Debug.warn(`${debugResult.length} debugs found in XHR request to ${settings.url}`);
                    for (let i = 0; i < debugResult.length; i++) {
                        self._putError('Debug found in Ajax:' + debugResult[i], settings.url, '0');
                    }
                }
            }
        };

        $(document).ajaxSuccess(responseFunction);
        $(document).ajaxError(responseFunction);
    };

    filterDebugMessage(str) {

        let debugResult = [];

        // Html debug
        let HtmlDebugRegex = /<div class="cake-debug-output">(.|\n)*?(.*)<\/div>/g;
        let htmlRes;
        do {
            htmlRes = HtmlDebugRegex.exec(str);

            if (htmlRes) {
                // Cleanup the match
                let returnString = htmlRes[0].substr(31);
                returnString = returnString.substr(0, returnString.length - 6);
                debugResult.push(Lib.String.decodeEntities(returnString));
            }
        } while (htmlRes);

        // Html debug
        let StringDebugRegex = /.*?(.|\n)########## DEBUG ##########(.|\n)*?(.*)###########################/g;
        let stringRes;
        do {
            stringRes = StringDebugRegex.exec(str);
            if (stringRes) {
                debugResult.push('<pre>' + stringRes[0] + '</pre>');
            }
        } while (stringRes);

        return debugResult;

    }

    /**
     *
     */
    jsErrorModal() {
        if (this.caughtErrors.length) {
            Lib.Modal.createFromTemplate('js-errors', {}, {
                onOpen: () => {
                    let errorHolder = $('.modal .modal-content [data-js-errors]');
                    $.each(this.caughtErrors, (i, err) => {
                        let errorRow = Lib.Template.parse('js-error-row', {
                            message: err.msg
                        });
                        errorRow.appendTo(errorHolder);
                    });
                }
            });
        }
    };

    newDevtool(devtool) {

        if ('additionaldata' in devtool) {
            devtool.additionaldata = JSON.stringify(devtool.additionaldata);
        }

        $('#dev-tools').prepend(Lib.Template.parse('dev-tool', devtool));
    }

    /**
     *
     * @param errorMsg
     * @param url
     * @param lineNumber
     */
    _putError(errorMsg, url, lineNumber) {
        this.caughtErrors.push({
            msg: errorMsg,
            url: url,
            lineNumber: lineNumber
        });

        this.getDevToolEl('js-errors').removeClass('bg-success').addClass('bg-danger');
    };

    getDevToolEl(devtool) {
        return $('#dev-tools').find('[data-devtool="' + devtool + '"]');
    }
}

Lib.Devtools = new Devtools;
